import { IconType, SvgIcon } from './SvgIcon';

export const CheckIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <path
      d="M15.5832 6C15.2498 5.66667 14.7498 5.66667 14.4165 6L8.1665 12.25L5.58317 9.66667C5.24984 9.33333 4.74984 9.33333 4.4165 9.66667C4.08317 10 4.08317 10.5 4.4165 10.8333L7.58317 14C7.74984 14.1667 7.9165 14.25 8.1665 14.25C8.4165 14.25 8.58317 14.1667 8.74984 14L15.5832 7.16667C15.9165 6.83333 15.9165 6.33333 15.5832 6Z"
      fill="currentColor"
    />
  </SvgIcon>
);

CheckIcon.displayName = 'CheckIcon';
